import { Skeleton } from '@mui/material'
import { number, oneOfType, shape, string } from 'prop-types'

const SkeletonFilled = ({ width, height, skeletonProps }) => {
	return <Skeleton variant="rectangular" width={width} height={height} {...skeletonProps} />
}

SkeletonFilled.defaultProps = {
	...Skeleton.defaultProps,
	width: 400,
	height: 400,
}

SkeletonFilled.propTypes = {
	...Skeleton.propTypes,
	/**
	 * width of skeleton
	 */
	width: oneOfType([number, string]).isRequired,
	/**
	 * height of skeleton
	 */
	height: oneOfType([number, string]).isRequired,
	/**
	 * Material Skeleton Props
	 */
	skeletonProps: shape({ ...Skeleton.propTypes }),
}

export default SkeletonFilled
